var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: { "has-logo": _vm.showLogo } },
    [
      _c("SiderAvatar"),
      _c(
        "el-scrollbar",
        { attrs: { "wrap-class": "scrollbar-wrapper" } },
        [
          _c(
            "el-menu",
            {
              ref: "menuRef",
              class: ["hok-menu"],
              attrs: {
                "default-active": _vm.activeMenu,
                "background-color": "#263480",
                "text-color": "#ffffff",
                "unique-opened": false,
                "active-text-color": "#ffffff",
                "collapse-transition": false,
                mode: "vertical",
              },
            },
            [
              _c(
                "el-menu-item",
                {
                  staticClass: "submenu-home",
                  attrs: { index: "/home" },
                  on: { click: _vm.changeHome },
                },
                [
                  _c("img", {
                    staticClass: "svg-icon",
                    staticStyle: {
                      "margin-right": "5px",
                      width: "20px",
                      height: "20px",
                    },
                    attrs: { src: require("@/icons/svg/sy.svg"), alt: "" },
                  }),
                  _vm._v("首页 "),
                ]
              ),
              _vm._l(_vm.sidebarRouters, function (route, index) {
                return _c("SidebarItem", {
                  key: route.path + index,
                  attrs: { item: route, "base-path": route.path },
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }